import React from 'react'
import ReactDOM from 'react-dom/client'
import TeamTimeTrackerFinal from '../team_time_tracker_final.tsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <TeamTimeTrackerFinal />
  </React.StrictMode>,
)
